import React, { useEffect, useState } from "react";
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

export default function SourceRowName({ name, variant = "body2", sx = {} }) {
  const [copyStatus, setCopyStatus] = useState("");

  useEffect(() => {
    setCopyStatus("");
  }, [name]);

  useEffect(() => {
    if (!copyStatus) return;
    const timer = setTimeout(() => setCopyStatus(""), 2500);
    return () => clearTimeout(timer);
  }, [copyStatus]);

  const copyName = async () => {
    try {
      await navigator.clipboard.writeText(name);
      setCopyStatus("copied");
    } catch {
      setCopyStatus("failed");
    }
  };

  return (
    <Stack
      direction='row'
      alignItems='flex-start'
      spacing={0.5}
      sx={{ minWidth: 0 }}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <Typography
        variant={variant}
        fontWeight={600}
        color='text.primary'
        sx={{
          minWidth: 0,
          overflowWrap: "anywhere",
          lineHeight: 1.5,
          ...sx,
          userSelect: "text",
          cursor: "text",
        }}
      >
        {name || "Unnamed row"}
      </Typography>
      {name && (
        <Tooltip
          title={copyStatus === "copied"
            ? "Copied!"
            : copyStatus === "failed"
              ? "Unable to copy. Select the name and copy it manually."
              : "Copy source row name"}
          arrow
        >
          <IconButton
            size='small'
            aria-label='Copy source row name'
            onClick={copyName}
            sx={{ p: 0.25, flexShrink: 0, color: copyStatus === "copied" ? "success.main" : "text.secondary" }}
          >
            {copyStatus === "copied"
              ? <CheckRoundedIcon sx={{ fontSize: 17 }} />
              : <ContentCopyRoundedIcon sx={{ fontSize: 17 }} />}
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
}
